export type CancellationToken = {
	isCancelled: boolean;
};

export function createCancellationToken(isCancelled = false): CancellationToken {
	return {
		isCancelled,
	};
}
